import { useTrackEvent } from "@Data-Protocol/event-tracker"
import {
  aBannerVisible,
  aCurrentBanner,
  aCurrentCaption,
  aIsPlaying,
  useAtomValue,
  useSetAtom,
} from "~/atoms"
import { cn } from "~/utils"
import { PaperIcon } from "./icons"

export default function TopBanners({
  isControlBarVisible,
}: {
  isControlBarVisible: boolean
}) {
  const currentBanner = useAtomValue(aCurrentBanner)
  const bannerVisible = useAtomValue(aBannerVisible)
  const currentCaption = useAtomValue(aCurrentCaption)
  const setIsPlaying = useSetAtom(aIsPlaying)

  const { trackAction } = useTrackEvent({
    name: "resource",
    type: "click",
  })

  return (
    <div
      className={cn(
        "fixed right-0 p-3 transition-all duration-300 sm:p-4",
        !bannerVisible && "translate-x-full opacity-0",
        currentCaption && "top-0 sm:top-10",
        isControlBarVisible ? "bottom-2 sm:top-10" : "bottom-0 sm:top-10"
      )}
    >
      {currentBanner && (
        <>
          <a
            href={currentBanner.url}
            target="_blank"
            rel="noreferrer"
            onClick={(e) => {
              e.stopPropagation()
              setIsPlaying(false)
              trackAction({
                action: currentBanner.url,
                action_meta: {
                  ...currentBanner,
                },
              })
            }}
          >
            <div
              id="banner"
              data-disable-control="true"
              className="flex items-center gap-2 rounded-2xl bg-white py-1 pl-2 pr-3 text-sm shadow-2xl sm:gap-3 sm:py-3 sm:pl-3 sm:pr-6"
            >
              <span
                data-disable-control="true"
                className="rounded-lg bg-[#E5D9FC] p-1 sm:p-2"
              >
                <PaperIcon
                  data-disable-control="true"
                  className="h-3 w-3 sm:h-6 sm:w-6"
                />
              </span>
              <div data-disable-control="true">
                <p
                  data-disable-control="true"
                  className="mb-px hidden sm:block"
                >
                  Check out this resource:
                </p>
                <span
                  data-disable-control="true"
                  className="block text-[8px] font-semibold underline-offset-2 hover:no-underline sm:text-sm sm:underline"
                >
                  {currentBanner.name}
                </span>
              </div>
            </div>
          </a>
        </>
      )}
    </div>
  )
}
